import React, { Component } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { dismissible } from "MODULES/shared/decorators";

export class DropDown extends Component {
  static propTypes = {
    visible: PropTypes.bool.isRequired,
    close: PropTypes.func.isRequired,
    toggle: PropTypes.func.isRequired,
    menuClass: PropTypes.string,
    children: PropTypes.oneOfType([
      PropTypes.element,
      PropTypes.arrayOf(PropTypes.element)
    ]),
    label: PropTypes.label
  };

  static defaultProps = {
    label: "Actions"
  };

  getChildContext() {
    return { close: this.props.close };
  }

  render() {
    const {
      menuClass,
      children,
      visible,
      toggle,
      label = "Actions"
    } = this.props;

    const classes = classNames("dropdown", { open: visible });

    return (
      <div className={classes}>
        <button className="btn btn-info" onClick={toggle}>
          {label}&nbsp;&nbsp;
          <i className="fa fa-fw fa-caret-down" />
        </button>
        <ul className={`dropdown-menu ${menuClass}`}>{children}</ul>
      </div>
    );
  }
}

DropDown.childContextTypes = {
  close: PropTypes.func
};

export default dismissible(DropDown);



// WEBPACK FOOTER //
// ./app/modules/shared/components/ActionDropDown/ActionDropDown.jsx